export const defaultState = {
	name: '',
	account: '',
	location: '',
	locations_count: 0,
	sessions_count: 0,
	session_items_count: 0,
	ffl_boss_linked: false,
};
